import classNames from "classnames"
import { twMerge } from "tailwind-merge"

/**
 *  A helper function that combines the `classNames` function from the `classnames` library
 * with the `overrideTailwindClasses` function from the `tailwind-override` library.
 */
export function cn(...inputs: classNames.ArgumentArray) {
  return twMerge(classNames(inputs))
}
